// extracted by mini-css-extract-plugin
module.exports = {"hidden":"searchArea_hidden__ENSz6","textEmphasis":"searchArea_textEmphasis__p_klJ","wrapper":"searchArea_wrapper__pVPJ0"};